import { BasicQuestion } from "../../models";
import { ProductSharedSettingsBuilder } from "../builders";
import { ProductType } from "../enums";

/**
 * Product shared settings
 * *Manages settings shared by all [Product];
 */
export class ProductSharedSettings {
  public readonly isActive: boolean;
  public readonly name: string;
  public readonly type: ProductType;
  public readonly description: string;
  public readonly instructions: string;
  public readonly warning: string;
  public readonly questions: BasicQuestion[];
  public readonly serviceFee?: number;
  public readonly tips?: number[];

  /**
   * Creates an instance of product shared settings.
   * @param builder
   */
  constructor(builder: ProductSharedSettingsBuilder) {
    this.isActive = builder.isActive;
    this.name = builder.name;
    this.type = builder.type;
    this.description = builder.description;
    this.instructions = builder.instructions;
    this.warning = builder.warning;
    this.questions = builder.questions;
    this.serviceFee = builder.serviceFee;
    this.tips = builder.tips;
  }

  toJSON = () => ({
    isActive: this.isActive ? this.isActive : null,
    name: this.name ? this.name : null,
    type: this.type != null ? this.type : null,
    description: this.description ? this.description : null,
    instructions: this.instructions ? this.instructions : null,
    warning: this.warning ? this.warning : null,
    questions: this.questions
      ? this.questions.map(question => question.toJSON())
      : null,
    serviceFee: this.serviceFee ? this.serviceFee * 100 : null,
    tips: this.tips ? this.tips.map(tip => tip * 100) : null
  });
}
